<template>
    <div class="tips">
        <div class="vote-count">{{getText}}</div>
        <div class="time" v-if="timeText">{{timeText}}</div>
    </div>
</template>
<script>
export default {
    props: ['fields','isFinish'],
    data() {
        return {
            
        }
    },
    computed: {
        // 总表态人数
        voteCount() {
            return this.fields?.options.reduce((acc,cur)=>{
                return acc + cur.userCount
            },0)
        },
        // 已投票
        isVoted() {
            return this.fields?.userOptionId || false
        },
        getText() {
            let p1 = ''
            let p2 = ''

            if(this.voteCount) p1 = this.voteCount + '人已表态'
            if(!this.isVoted && !this.isFinish) p2 = '表态后可查看结果' // 未投票&未结束

            if(p1 && p2) return p1 + "，" + p2
            else return p1 + p2
        },
        timeText() {
            if(!this.fields?.endTime) return '' // 永久讨论，不展示
            if(this.isFinish) return '投票已结束'
            const currentTimestamp = Date.now();
            const timeDifference = this.fields?.endTime - currentTimestamp;
            const daysRemaining = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
            return `还有${daysRemaining}天结束`
        }
    }
}
</script>
<style lang="less" scoped>
    .tips {
        margin-top: 16px;/*px*/
        width: 100%;
        height: 36px; /*px*/
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 24px;/*px*/
        color: #999999;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .center {
        justify-content: center;
    }
</style>